import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { DropdownContentDirective } from '../../../shared/components/dropdown/dropdown-content.directive';
import { DropdownTriggerDirective } from '../../../shared/components/dropdown/dropdown-trigger.directive';
import { DropdownComponent } from '../../../shared/components/dropdown/dropdown.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { GetProductDetailQuery } from '../../common/gql/graphql';

import { BaseOfferLabelComponent } from './base-offer-label.component';

@Component({
    selector: 'kb-offer-label',
    templateUrl: './offer-label.component.html',
    styleUrls: ['./offer-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        DropdownComponent,
        DropdownTriggerDirective,
        FontAwesomeModule,
        DropdownContentDirective,
        PictureComponent,
    ],
})
export class OfferLabelComponent extends BaseOfferLabelComponent {
    @Input() product: GetProductDetailQuery['product'];

    get collections() {
        return this.product?.collections;
    }

    hasFacetValue(facetValueCode: string): boolean {
        return !!(
            this.product?.facetValues.some((fv) => fv.code === facetValueCode) ||
            this.product?.variants.some((v) => v.facetValues.some((fv) => fv.code === facetValueCode))
        );
    }

    calculateRrpDiscount() {
        const rrpDiscounts = [
            ...new Set(
                this.product?.variants
                    .map((variant) => {
                        const rrp = variant.customFields?.rrp;
                        if (rrp) {
                            return Math.round((100 * (rrp - variant.priceWithTax)) / rrp);
                        } else {
                            return 0;
                        }
                    })
                    .filter((pc) => 0 < pc),
            ),
        ]
            .sort((a, b) => a - b)
            .reverse();
        if (rrpDiscounts.length >= 1) {
            this.rrpDiscount = `${Math.round(rrpDiscounts[0])}%`;
            this.rrpDiscountQualifier = rrpDiscounts.length > 1;
        } else {
            this.rrpDiscount = undefined;
        }
    }
}
